export const theme = {
    primaryDark: 'rgb(0, 0, 9)',
    primaryLight: '#EFFFFA',
    primaryHover: '#343078',
    mobile: '576px',
  }